export default "__VITE_PUBLIC_ASSET__30f6be5b__"